<template>
  <div>
    <div class="page-breadcrumb border-bottom">
      <div class="row">
        <div class="col-lg-3 col-md-4 col-xs-12 align-self-center">
          <h5 class="font-medium text-uppercase mb-0">Stripe</h5>
        </div>
        <div class="col-lg-9 col-md-8 col-xs-12 align-self-center">
          <nav aria-label="breadcrumb" class="float-left mt-2 float-md-right">
            <ol class="p-0 mb-0 breadcrumb justify-content-end">
              <li class="breadcrumb-item">
                <a>Home</a>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                Stripe
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
    <div class="page-content container-fluid">
      <aha-tabs class="bridge-tabs" :items="tabsJson" :value.prop="activeIndex" @change="selectTab"></aha-tabs>
      <keep-alive>
        <component :is="activeTab.component" :key="activeTab.key" />
      </keep-alive>
    </div>
  </div>
</template>

<script>
import StripeBridgeFeatures from './stripe-bridge/StripeBridgeFeatures.vue'
import StripeBridgeProducts from './stripe-bridge/StripeBridgeProducts.vue'
import StripeBridgeSync from './stripe-bridge/StripeBridgeSync.vue'
import { loadCatalog, resetCatalog } from './stripe-bridge/catalogStore'
import nativeAhaElements from './stripe-bridge/nativeAhaElements'

export default {
  name: 'StripeBridge',
  components: { ...nativeAhaElements, StripeBridgeFeatures, StripeBridgeProducts, StripeBridgeSync },
  data() {
    return {
      activeIndex: 0,
      tabs: [
        { key: 'features', label: 'Features', component: 'StripeBridgeFeatures' },
        { key: 'products', label: 'Products', component: 'StripeBridgeProducts' },
        { key: 'sync', label: 'Sync', component: 'StripeBridgeSync' },
      ],
    }
  },
  created() {
    resetCatalog()
    loadCatalog()
  },
  computed: {
    activeTab() {
      return this.tabs[this.activeIndex]
    },
    tabsJson() {
      return JSON.stringify(this.tabs.map(({ key, label }) => ({ key, label })))
    },
  },
  methods: {
    selectTab(event) {
      if (event.detail && typeof event.detail.value === 'number') this.activeIndex = event.detail.value
    },
  },
}
</script>

<style lang="scss" scoped>
.bridge-tabs {
  display: block;
  margin-bottom: var(--aha-space-16);
}
</style>
